export enum PresenceReportActions {
  fetchOrgans = '[Organs]: fetch Organs',
  fetchOrgansSuccess = '[Organs]: fetch Organs success',
  fetchOrgansFailure = '[Organs]:  fetch Organs failure',
  publishPresenceReportDetails = '[Presence Report]: fetch Organs',
  publishPresenceReportDetailsSuccess = '[Presence Report]:  Publish presence report success',
  publishPresenceReportDetailsFailure = '[Presence Report]:  Publish presence report failure'
}
